module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/images.png?ade07630640c3e3b9b619ef79ab0c02b";